import { render, staticRenderFns } from "./del.vue?vue&type=template&id=aa645f60"
import script from "./del.vue?vue&type=script&lang=js"
export * from "./del.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports